export default function fileExportElement(response) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const fileName = response.headers['content-disposition'].split("filename=")[1].replaceAll('"', '');
    link.setAttribute('download', fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
}
